<ng-container [formGroup]="form">
  <div class="custom-upload-container flex flex-col flex-start-stretch gap-12 flex-[1_1_0%]">
    @if (thumbnailImageSource) {
      <div class="flex flex-between-center md:flex-end-center gap-21">
        @if (isMobile || (cropper.active && cropper.ready)) {
          <button
            (click)="customUploadFileInput.click()"
            class="change-photo-btn"
            color="primary"
            data-test-id="customUpload-changePhoto-button"
            mat-button
            type="button"
          >
            Change photo
          </button>
        }
        <button
          (click)="removePhoto()"
          class="remove-photo-btn"
          color="warn"
          data-test-id="customUpload-removePhoto-button"
          mat-button
          type="button"
        >
          Remove photo
        </button>
      </div>
    }

    <div
      [hidden]="cropper.active"
      [ngClass]="{ 'box-with-image': thumbnailImageSource, error: isUploadFormInvalid() }"
      [style.background-image]="thumbnailImageSource ? safeThumbnailImageSource : null"
      (fileDropped)="uploadFileChanged($event)"
      class="file-upload-box"
      dragAndDropFile
    >
      <div class="file-upload-box-content flex flex-col flex-center-center md:gap-12 w-full">
        <div class="desc max-md:hidden">
          Choose photo from the gallery,
          <br />
          drag and drop your own image here
        </div>
        <div class="or max-md:hidden">or</div>
        <div>
          <input
            [accept]="acceptedMimeTypes"
            (change)="uploadFileChanged()"
            #customUploadFileInput
            data-test-id="customUpload-uploadFile-input"
            name="customBanner"
            style="display: none"
            type="file"
          />
          <button
            (click)="customUploadFileInput.click()"
            class="max-md:hidden"
            color="primary"
            mat-stroked-button
            type="button"
          >
            Add file
          </button>
          <div class="md:hidden flex flex-col flex-center-center gap-6 sm:gap-12">
            <img
              (click)="customUploadFileInput.click()"
              class="photo-upload-img"
              src="/assets/my7n-ui/icons/photo_upload.svg"
            />
            <button
              (click)="customUploadFileInput.click()"
              color="primary"
              data-test-id="customUpload-addFile-button"
              mat-button
              type="button"
            >
              Add file
            </button>
          </div>
        </div>
        <div class="hint typography-small-paragraph">Recommended resolution is 1920 x 400px</div>
      </div>
    </div>
    <div class="cropper-container flex flex-col flex-center-center flex-auto">
      @if (cropper.active && !cropper.ready) {
        <div class="cropper-loader flex flex-col flex-center-center flex-auto">
          <loader color="primary"></loader>
        </div>
      }
      @if (cropper.active) {
        <image-cropper
          [aspectRatio]="1920 / 400"
          [imageFile]="cropper.image"
          [maintainAspectRatio]="true"
          [resizeToWidth]="1920"
          (cropperReady)="cropperReady()"
          (imageCropped)="imageCropped($event)"
          (loadImageFailed)="loadImageFailed()"
          format="png"
          output="base64"
        ></image-cropper>
      }
    </div>
  </div>
</ng-container>
